
const TYPE_HANDLERS = {
    once
};

const TRINITY_TRIGGERED_ATTRIBUTE = "jsh-trinity--triggered";

/**
 * Decides whether a trinity should be triggered.
 * @param element the element which posses the trinity
 * @returns {boolean} whether or not the trinity should be triggered
 */
export function shouldTriggerTrinity(element) {

    const trinityHandlerName = Object.keys(TYPE_HANDLERS)
        .find(handlerName => element.hasAttribute(`jsh-trinity-trigger-${handlerName}`));

    if(!trinityHandlerName) {
        return true;
    }

    return TYPE_HANDLERS[trinityHandlerName](element);
}

function once(element) {
    const triggered = element.hasAttribute(TRINITY_TRIGGERED_ATTRIBUTE);
    if(!triggered) {
        element.setAttribute(TRINITY_TRIGGERED_ATTRIBUTE, "");
        return true;
    }
    return false;
}

export default {
    shouldTriggerTrinity
};